import { render, staticRenderFns } from "./department-add.vue?vue&type=template&id=09b40c5c&scoped=true&"
import script from "./department-add.vue?vue&type=script&lang=js&"
export * from "./department-add.vue?vue&type=script&lang=js&"
import style0 from "./department-add.vue?vue&type=style&index=0&id=09b40c5c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b40c5c",
  null
  
)

export default component.exports